<template>
  <div class="building-checklist">
    <div class="checklist-header">
      <h4 class="text-center">BUILDING/ACCESSORY CHECK-OFF LIST</h4>
    </div>
    <div class="checklist-content">
      <!-- Tube Size and Roof Pitch -->
      <div class="row mb-3">
        <div class="col-3">
          <span class="label">Tube size</span>
        </div>
        <div class="col-3">
          <span class="circled" v-if="building.thickness === '2x2'">2X2</span>
          <span v-else>2X2</span>
        </div>
        <div class="col-3">
          <span class="circled" v-if="building.thickness === '2x3'">2X3</span>
          <span v-else>2X3</span>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-3">
          <span class="label">Roof pitch</span>
        </div>
        <div class="col-9">
          <span class="filled-in">{{ roofPitch }}</span>
        </div>
      </div>

      <!-- Roof Style -->
      <div class="row mb-3">
        <div class="col-3">
          <span class="label">Roof Style</span>
        </div>
        <div class="col-3">
          <span class="circled" v-if="building.roof.design === 'Vertical'"
            >Vertical</span
          >
          <span v-else>Vertical</span>
        </div>
        <div class="col-3">
          <span class="circled" v-if="building.roof.design === 'Horizontal'"
            >Horizontal</span
          >
          <span v-else>Horizontal</span>
        </div>
      </div>

      <!-- Deluxe Trim -->
      <div class="row mb-3">
        <div class="col-3">
          <span class="label">Deluxe Trim</span>
        </div>
        <div class="col-3">
          <span
            class="circled"
            v-if="building.deluxeTrimPackage.doDeluxeTrim === true"
            >YES</span
          >
          <span v-else>YES</span>
        </div>
        <div class="col-3">
          <span
            class="circled"
            v-if="building.deluxeTrimPackage.doDeluxeTrim === false"
            >NO</span
          >
          <span v-else>NO</span>
        </div>
      </div>

      <!-- Vented Closure -->
      <div class="row mb-3">
        <div class="col-3">
          <span class="label">Vented Closure</span>
        </div>
        <div class="col-3">
          <span class="circled" v-if="building.closure === true">YES</span>
          <span v-else>YES</span>
        </div>
        <div class="col-3">
          <span class="circled" v-if="building.closure === false">NO</span>
          <span v-else>NO</span>
        </div>
      </div>

      <!-- Man Door Swing -->
      <div class="row mb-3">
        <div class="col-3">
          <span class="label">Man Door Swing</span>
        </div>
        <div class="col-2">
          <span>YES</span>
        </div>
        <div class="col-2">
          <span>NO</span>
        </div>
        <div class="col-5">
          <span class="label">IF YES:</span>
          <span class="ml-2">OUT (LEFT)</span>
          <span class="ml-3">OUT (RIGHT)</span>
        </div>
      </div>

      <!-- Grade All -->
      <div class="row mb-3">
        <div class="col-3">
          <span class="label">Grade All</span>
        </div>
        <div class="col-3">
          <span class="circled" v-if="building.foundation.doGrading === true"
            >YES</span
          >
          <span v-else>YES</span>
        </div>
        <div class="col-3">
          <span class="circled" v-if="!building.foundation.doGrading">NO</span>
          <span v-else>NO</span>
        </div>
      </div>

      <!-- Skylight panels -->
      <div class="row mb-3">
        <div class="col-3">
          <span class="label">Skylight panels</span>
        </div>
        <div class="col-2">
          <span class="circled" v-if="building.skyLights > 0">YES</span>
          <span v-else>YES</span>
        </div>
        <div class="col-2">
          <span class="circled" v-if="building.skyLights === 0">NO</span>
          <span v-else>NO</span>
        </div>
        <div class="col-5">
          <span class="label">IF YES:</span>
          <span class="ml-2">CLEAR</span>
          <span class="ml-3">OPAL</span>
        </div>
      </div>

      <!-- Location -->
      <div class="row mb-3">
        <div class="col-3 offset-3">
          <span class="label">Location</span>
        </div>
        <div class="col-2">
          <span>Roof</span>
        </div>
        <div class="col-2">
          <span>Walls</span>
        </div>
        <div class="col-2">
          <span>Gable Ends</span>
        </div>
      </div>

      <!-- Overhangs -->
      <div class="row mb-3">
        <div class="col-3">
          <span class="label">Overhangs, in inches</span>
        </div>
        <div class="col-9">
          <span class="label">Eave</span>
          <span class="filled-in">{{ eaveOverhang }}</span>
          <span class="label ml-4">Gable</span>
          <span class="filled-in">{{ gableOverhang }}</span>
        </div>
      </div>

      <!-- Panel Colors -->
      <div class="row mb-3">
        <div class="col-3">
          <span class="label">Panel Colors</span>
        </div>
        <div class="col-9">
          <span class="label">Roof</span>
          <span class="filled-in">{{ building.roof.color || '-' }}</span>
          <span class="label ml-3">Walls</span>
          <span class="filled-in">{{ building.walls.color || '-' }}</span>
          <span class="label ml-3">Trim</span>
          <span class="filled-in">{{ building.trimColor || '-' }}</span>
        </div>
      </div>

      <!-- Man Door Color -->
      <div class="row mb-3">
        <div class="col-3">
          <span class="label">Man Door Color</span>
        </div>
        <div class="col-9">
          <span>Standard (WHITE)</span>
          <span class="ml-5">Special (ORDER)</span>
          <span class="filled-in ml-2">{{ manDoorColor }}</span>
        </div>
      </div>

      <!-- Insulation -->
      <div class="row mb-3">
        <div class="col-3">
          <span class="label">Insulation</span>
        </div>
        <div class="col-2">
          <span class="circled" v-if="hasInsulation">YES</span>
          <span v-else>YES</span>
        </div>
        <div class="col-2">
          <span class="circled" v-if="!hasInsulation">NO</span>
          <span v-else>NO</span>
        </div>
        <div class="col-5" v-if="hasInsulation">
          <span class="label">Type:</span>
          <span class="filled-in">{{ insulationType }}</span>
        </div>
      </div>

      <div class="row mb-3" v-if="hasInsulation">
        <div class="col-3 offset-3">
          <span class="circled" v-if="roofInsulation">Roof Only</span>
          <span v-else>Roof Only</span>
        </div>
        <div class="col-3">
          <span class="circled" v-if="wallsInsulation">Walls Only</span>
          <span v-else>Walls Only</span>
        </div>
        <div class="col-3">
          <span class="circled" v-if="bothInsulation">Roof & Walls</span>
          <span v-else>Roof & Walls</span>
        </div>
      </div>

      <!-- DOORS Section -->
      <div class="section-header mt-4 mb-3">
        <h5>DOORS</h5>
      </div>

      <!-- Maker -->
      <div class="row mb-3">
        <div class="col-3">
          <span class="label">Maker</span>
        </div>
        <div class="col-9">
          <span>Janus</span>
          <span class="ml-5">Wayne Dalton – perimeter seal? Y N</span>
        </div>
      </div>

      <!-- Door Color -->
      <div class="row mb-3">
        <div class="col-3">
          <span class="label">Door Color</span>
        </div>
        <div class="col-9">
          <span class="filled-in">{{ doorColor }}</span>
        </div>
      </div>

      <!-- Model/Style -->
      <div class="row mb-3">
        <div class="col-3">
          <span class="label">Model/Style</span>
        </div>
        <div class="col-9">
          <span class="filled-in">{{ doorModel }}</span>
          <span class="label ml-5">Lites Style</span>
          <span class="signature-line"></span>
        </div>
      </div>

      <!-- Electric Opener -->
      <div class="row mb-3">
        <div class="col-3">
          <span class="label">Electric Opener</span>
        </div>
        <div class="col-3">
          <span>YES</span>
        </div>
        <div class="col-2">
          <span>NO</span>
        </div>
        <div class="col-4">
          <span>(RIGHT OR LEFT MOUNT)</span>
        </div>
      </div>

      <!-- Require Side Frame -->
      <div class="row mb-3">
        <div class="col-3">
          <span class="label">Require Side Frame</span>
        </div>
        <div class="col-3">
          <span>YES</span>
        </div>
        <div class="col-3">
          <span>NO</span>
        </div>
      </div>

      <!-- CONCRETE Section -->
      <div class="section-header mt-4 mb-3">
        <h5>CONCRETE</h5>
      </div>

      <!-- Concrete to be done -->
      <div class="row mb-3">
        <div class="col-3">
          <span class="label">Concrete to be done</span>
        </div>
        <div class="col-9">
          <span class="circled" v-if="concreteType === 'piers'">Piers</span>
          <span v-else>Piers</span>
          <span class="ml-3 circled" v-if="concreteType === 'slab w/ footings'"
            >Footings/Slab</span
          >
          <span class="ml-3" v-else>Footings/Slab</span>
          <span class="ml-3 circled" v-if="concreteType === 'stem wall'"
            >Stem wall</span
          >
          <span class="ml-3" v-else>Stem wall</span>
          <span class="ml-3 circled" v-if="concreteType === 'footings'"
            >Footings</span
          >
          <span class="ml-3" v-else>Footings</span>
        </div>
      </div>

      <!-- IF Stemwall note -->
      <div class="row mb-3">
        <div class="col-12">
          <span class="note"
            >IF Stemwall – all doors need critical dimension callouts</span
          >
        </div>
      </div>

      <!-- Anchor Bolt Type -->
      <div class="row mb-3">
        <div class="col-3">
          <span class="label">Anchor Bolt Type</span>
        </div>
        <div class="col-9">
          <span>J Bolts</span>
          <span class="ml-3">P.A.B.</span>
          <span
            class="ml-3 circled"
            v-if="building.foundation.includeTitanBolts"
            >Titans</span
          >
          <span class="ml-3" v-else>Titans</span>
          <span class="ml-3">Duck Bills</span>
        </div>
      </div>

      <!-- Customer Approval Section -->
      <div class="signature-section mt-5">
        <div class="row mb-3">
          <div class="col-12">
            <span class="label">CUSTOMER APPROVAL</span>
            <span class="signature-line"></span>
            <span class="label ml-4">DATE</span>
            <span class="signature-line date-line"></span>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <span class="label">MDI REPRESENTATIVE</span>
            <span class="signature-line"></span>
            <span class="label ml-4">DATE</span>
            <span class="signature-line date-line"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'BuildingChecklist',
  props: {
    building: {
      type: Object,
      required: true,
    },
  },
  computed: {
    roofPitch() {
      return this.building.roof?.pitch?.slope || '___/12'
    },
    eaveOverhang() {
      // Get eave overhang - check different properties
      const left = this.building.roof?.leftEaveOverhang?.overhang
      const right = this.building.roof?.rightEaveOverhang?.overhang
      const generic = this.building.roof?.eaveOverhang?.overhang
      const overhang = left || right || generic || '2ft'
      // Convert feet to inches (e.g., "2ft" -> "24"")
      const match = overhang.match(/(\d+)ft/)
      if (match) {
        const feet = parseInt(match[1])
        return `${feet * 12}"`
      }
      return overhang || '___'
    },
    gableOverhang() {
      // Get gable overhang
      const front = this.building.roof?.frontGableOverhang?.overhang
      const end = this.building.roof?.endGableOverhang?.overhang
      const generic = this.building.roof?.gableOverhang?.overhang
      const overhang = front || end || generic || '2ft'
      // Convert feet to inches (e.g., "2ft" -> "24"")
      const match = overhang.match(/(\d+)ft/)
      if (match) {
        const feet = parseInt(match[1])
        return `${feet * 12}"`
      }
      return overhang || '___'
    },
    manDoorColor() {
      // Try to get man door color from various sources
      const manDoorList = this.building.manDoorList || []
      if (manDoorList.length > 0 && manDoorList[0].color) {
        return manDoorList[0].color
      }
      return '-'
    },
    hasInsulation() {
      const roofType = this.building.roof?.insulation?.type || 'None'
      const wallType = this.building.walls?.insulation?.type || 'None'
      return roofType !== 'None' || wallType !== 'None'
    },
    insulationType() {
      const roofType = this.building.roof?.insulation?.type || 'None'
      const wallType = this.building.walls?.insulation?.type || 'None'

      if (roofType !== 'None' && wallType !== 'None') {
        return roofType === wallType ? roofType : `${roofType} / ${wallType}`
      } else if (roofType !== 'None') {
        return roofType
      } else if (wallType !== 'None') {
        return wallType
      }
      return 'None'
    },
    roofInsulation() {
      const roofType = this.building.roof?.insulation?.type || 'None'
      const wallType = this.building.walls?.insulation?.type || 'None'
      return roofType !== 'None' && wallType === 'None'
    },
    wallsInsulation() {
      const roofType = this.building.roof?.insulation?.type || 'None'
      const wallType = this.building.walls?.insulation?.type || 'None'
      return roofType === 'None' && wallType !== 'None'
    },
    bothInsulation() {
      const roofType = this.building.roof?.insulation?.type || 'None'
      const wallType = this.building.walls?.insulation?.type || 'None'
      return roofType !== 'None' && wallType !== 'None'
    },
    doorColor() {
      // Try to get door color from roll doors or shed doors
      const rollDoors = this.building.rollDoors || []
      const shedDoors = this.building.shedDoors || []

      if (rollDoors.length > 0 && rollDoors[0].color) {
        return rollDoors[0].color
      }
      if (shedDoors.length > 0 && shedDoors[0].color) {
        return shedDoors[0].color
      }
      return '-'
    },
    doorModel() {
      const rollDoors = this.building.rollDoors || []
      const shedDoors = this.building.shedDoors || []

      if (rollDoors.length > 0 && rollDoors[0].model) {
        return rollDoors[0].model
      }
      if (shedDoors.length > 0 && shedDoors[0].model) {
        return shedDoors[0].model
      }
      return '-'
    },
    concreteType() {
      if (this.building.foundation?.doConcrete) {
        return this.building.foundation.anchors || ''
      }
      return ''
    },
  },
}
</script>

<style lang="scss" scoped>
.building-checklist {
  padding: 20px;
  font-family: Arial, sans-serif;
  font-size: 14px;
}

.checklist-header {
  margin-bottom: 20px;

  h4 {
    font-weight: bold;
    text-decoration: underline;
  }
}

.checklist-content {
  text-align: left;
}

.label {
  font-weight: bold;
}

.circled {
  border: 2px solid #000;
  border-radius: 50%;
  padding: 2px 8px;
  display: inline-block;
  font-weight: bold;
}

.filled-in {
  border-bottom: 1px solid #000;
  padding: 0 8px 2px 8px;
  display: inline-block;
  min-width: 80px;
}

.section-header {
  border-top: 2px solid #000;
  border-bottom: 2px solid #000;
  padding: 8px 0;
  text-align: center;

  h5 {
    margin: 0;
    font-weight: bold;
  }
}

.note {
  font-style: italic;
  text-align: center;
  display: block;
}

.signature-section {
  margin-top: 40px;
}

.signature-line {
  display: inline-block;
  border-bottom: 1px solid #000;
  min-width: 220px;
  margin-left: 8px;
}

.date-line {
  min-width: 120px;
}

@media print {
  .building-checklist {
    padding: 30px;
    font-size: 16px;
  }

  .circled {
    border: 3px solid #000;
  }
}
</style>
